import { render } from "./knowledgebasedetails2.vue?vue&type=template&id=1159527f&scoped=true"
import script from "./knowledgebasedetails2.vue?vue&type=script&lang=js"
export * from "./knowledgebasedetails2.vue?vue&type=script&lang=js"

import "./knowledgebasedetails2.vue?vue&type=style&index=0&id=1159527f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1159527f"

export default script